import React from "react";
import Navbar from '../accueil/navbar/Navbar';
import Footer from '../accueil/footer/Footer';
import Partenaires from "./partenaires/Partenaires"
// import "./body.css";

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class DisplayPartenaires extends React.Component {
    constructor() {
        super();
        this.state = {
            part: []
        }
    }

    componentDidMount = () => {
        fetch(SERVER_ADDRESS + '/partenaires')
            .then(res => res.json())
            .then(res => this.setState({ part: res }))
    }

    render() {
        return (
            <div className="sticky-wrap">
                <Navbar />
                <div className="block-partenaires">
                    <div className="title-center">
                        <strong className="title-partenaires">Nos partenaires</strong>
                    </div>                                                                                    
                    <div className="row wi-12 max-wi-1000 justify-content-center">
                        {this.state.part.map((partenaires) => (
                            <Partenaires
                                name={partenaires.name}
                                description={partenaires.description}
                                liens_logo={partenaires.liens_logo}
                                liens_site={partenaires.liens_site}
                                alt={partenaires.alt}
                            />
                        ))}
                    </div>
                </div>
                <div className="sticky-footer">
                    <Footer />
                </div>
            </div >
        )
    }
}

export default DisplayPartenaires;
